import Vue from 'vue'
import { Icon } from 'ant-design-vue';
const MyIcon = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2219081_hmu3zjilydq.js', // 在 iconfont.cn 上生成
});
Vue.component("MyIcon",MyIcon)
